import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { map, take } from 'rxjs';

import { TokenService } from '@tablesready/frontend-auth';
import { AuthRestaurantService } from '@tablesready/frontend-store';
import { PricePlansRestrictionsService } from '@tablesready/frontend-restrictions';
import { FrontendPaidFeatureService } from '@tablesready/frontend-paid-feature-alert';

export const businessPlanGuard = () => {
  // A session with no location has no plan to check
  if (inject(TokenService).hasNoLocationToken()) {
    return inject(Router).parseUrl('/profile/details');
  }

  const authRestaurantService = inject(AuthRestaurantService);
  const pricePlansRestrictionsService = inject(PricePlansRestrictionsService);
  const paidFeatureService = inject(FrontendPaidFeatureService);

  const user = authRestaurantService.get();
  const isLocationOnBusinessPlan = pricePlansRestrictionsService.availableForBusinessPlan(user.account.subscriptionType, user.location.recurly);

  if (!isLocationOnBusinessPlan) {
    return paidFeatureService.freePlanLocationModalDisplay(user, false)
      .pipe(
        take(1),
        map(() => false),
      );
  }

  return true;
};
